var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#4C6AFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.903 13.4c0-1.888-1.168-2.96-3.04-2.96-2.24 0-3.696 1.136-4.08 3.392h2.496c.224-.864.736-1.136 1.28-1.136.512 0 .816.304.816.848 0 .576-.304.912-.928 1.536l-4.688 4.608-.464 2.24h7.104l.464-2.256h-3.92l3.088-2.992c.624-.608 1.872-1.616 1.872-3.28zM24.116 15.592c0-1.792-1.264-2.368-2.16-2.368a3.13 3.13 0 00-1.92.656l.672-3.344h-2.496L15.94 21.928h2.496l1.04-5.2c.192-.96.752-1.248 1.328-1.248.32 0 .72.24.72.816a2.1 2.1 0 01-.048.432l-1.04 5.2h2.496l1.072-5.344c.064-.288.112-.64.112-.992z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/two.303fb981.svg";
export { SvgTwo as ReactComponent };